export default {
  UNSETTLED: {
    value: 100,
    label: '未确认',
  },
  ACCEPTED: {
    value: 101,
    label: '已确认',
  },
  PENDING: {
    value: 102,
    label: '处理中',
  },
  CANCELLED: {
    value: 103,
    label: '已取消',
  },
  COMPLETED: {
    value: 104,
    label: '已完成',
  },
}